export default __webpack_public_path__ + "static/media/tradingPlatformImg.4f1bf806.png";